module.exports = __webpack_public_path__ + "static/media/h1.37e8eeac.svg";